import React, { useEffect, useState } from "react";
import { X, ArchiveRestore, Loader2, Archive } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { DossierPill } from "./DossierLinker";

export function ArchiveTicketButton({ basePath, ticketId, onDone }) {
  const archive = async () => {
    if (!window.confirm("Archiver ce ticket ? Il disparaîtra du tableau mais pourra être restauré depuis les Archives.")) return;
    try {
      await api.patch(`${basePath}/${ticketId}/archive`, { done: true });
      toast.success("Ticket archivé");
      onDone();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Archivage impossible");
    }
  };
  return (
    <button onClick={archive} className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-sm text-norea-textMuted hover:text-red-600 hover:bg-red-50 transition-colors" data-testid="trello-archive-btn">
      <Archive className="w-4 h-4" /> Archiver
    </button>
  );
}

export function ArchivedTicketsModal({ basePath, onClose, onRestored }) {
  const [items, setItems] = useState(null);
  const load = () => api.get(basePath, { params: { archived: true } }).then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  useEffect(() => { load(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [basePath]);
  const restore = async (t) => {
    try {
      await api.patch(`${basePath}/${t.id}/archive`, { done: false });
      toast.success(`« ${t.title} » restauré`);
      load();
      onRestored();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Restauration impossible");
    }
  };
  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-start justify-center p-6 overflow-y-auto" onClick={onClose}>
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl border border-norea-border" onClick={(e) => e.stopPropagation()} data-testid="archived-tickets-modal">
        <div className="px-6 py-4 border-b border-norea-border flex items-center justify-between">
          <h3 className="font-heading text-xl font-medium text-norea-text flex items-center gap-2"><Archive className="w-5 h-5" /> Tickets archivés</h3>
          <button onClick={onClose} className="p-1.5 rounded hover:bg-norea-surfaceHover" data-testid="archived-close"><X className="w-4 h-4" /></button>
        </div>
        <div className="p-4 space-y-2 max-h-[70vh] overflow-y-auto">
          {items === null ? <div className="py-10 flex justify-center"><Loader2 className="w-5 h-5 animate-spin" /></div>
            : items.length === 0 ? <div className="py-10 text-center text-sm text-norea-textMuted italic" data-testid="archived-empty">Aucun ticket archivé</div>
            : items.map((t) => (
              <div key={t.id} className="flex items-center gap-3 p-3 rounded-lg border border-norea-border hover:bg-norea-surfaceHover" data-testid={`archived-ticket-${t.id}`}>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium truncate">{t.title}</div>
                  <div className="text-[11px] text-norea-textMuted">Archivé le {t.archived_at ? new Date(t.archived_at).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" }) : "—"}</div>
                  {t.dossiers?.length > 0 && <div className="flex flex-wrap gap-1 mt-1">{t.dossiers.map((d) => <DossierPill key={d.id} d={d} />)}</div>}
                </div>
                <button onClick={() => restore(t)} className="btn-secondary text-xs" data-testid={`archived-restore-${t.id}`}><ArchiveRestore className="w-3.5 h-3.5" /> Restaurer</button>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}
